/* People's Peps: reconstitution calculator.
   Arithmetic only, no data leaves the page.
     mg/mL   = peptide mass (mg) / diluent volume (mL)   (volume added is treated as final volume)
     mcg/mL  = mg/mL x 1000
     mcg/uL  = mg/mL                                      (numerically identical)
     mM      = mg/mL / molecular weight (g/mol) x 1000
     draw mL = amount (mg) / mg/mL ;  U-100 units = mL x 100
   Customizer-safe by construction: one re-entry guard, every handler delegated
   on document, per-section state re-hydrated on shopify:section:load scoped to
   e.target. Nothing reads document.currentScript. */
(function () {
  if (window.__ppCalcWired) return;
  window.__ppCalcWired = true;

  var SEL = '[data-pp-calc]';

  function num(v) {
    v = String(v == null ? '' : v).replace(/,/g, '.').replace(/[^0-9.\-]/g, '').trim();
    if (!v) return NaN;
    var n = parseFloat(v);
    return isFinite(n) ? n : NaN;
  }
  function fmt(n, d) {
    return n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function fmtLoose(n, maxd) {
    return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: maxd });
  }
  function fmtMcg(n) {                       /* whole numbers as-is, otherwise one decimal, no grouping (as drawn) */
    if (!isFinite(n)) return '--';
    var v = Math.abs(n - Math.round(n)) < 1e-9 ? Math.round(n) : Math.round(n * 10) / 10;
    return String(v) + ' mcg';
  }
  function q(root, s) { return root.querySelector(s); }
  function qa(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  /* Reads the vial content off a metafield string such as "10 mg" or "500 mcg". */
  function parseMass(str) {
    var n = num(str);
    if (!isFinite(n)) return NaN;
    return /mcg|µg|ug/i.test(String(str)) ? n / 1000 : n;
  }

  function unitOf(root) {
    var b = q(root, '[data-pp-calc-unit][aria-pressed="true"]');
    return b ? b.getAttribute('data-pp-calc-unit') : 'mcg';
  }
  function amountMg(root) {
    var a = num(q(root, '[data-pp-calc-amount]').value);
    if (!isFinite(a) || a < 0) return NaN;
    return unitOf(root) === 'mg' ? a : a / 1000;
  }

  function markPills(root) {
    var ml = num(q(root, '[data-pp-calc-ml]').value);
    qa(root, '[data-pp-calc-pill]').forEach(function (b) {
      var v = num(b.getAttribute('data-pp-calc-pill'));
      b.setAttribute('aria-pressed', isFinite(ml) && Math.abs(v - ml) < 1e-9 ? 'true' : 'false');
    });
  }

  function compute(root, opts) {
    opts = opts || {};
    var mg = num(q(root, '[data-pp-calc-mg]').value);
    var ml = num(q(root, '[data-pp-calc-ml]').value);
    var mw = num(q(root, '[data-pp-calc-mw]').value);
    var ok = isFinite(mg) && mg > 0 && isFinite(ml) && ml > 0;
    var conc = ok ? mg / ml : NaN;                     /* mg/mL */

    var set = function (name, text) {
      var el = q(root, '[data-pp-calc-out="' + name + '"]');
      if (el) el.textContent = text;
    };
    set('mgml', ok ? fmt(conc, 3) : '--');
    set('mcgml', ok ? fmtLoose(conc * 1000, conc * 1000 >= 100 ? 0 : 1) : '--');
    set('mcgul', ok ? fmt(conc, 2) : '--');
    set('mm', ok && isFinite(mw) && mw > 0 ? fmt(conc / mw * 1000, 3) : '--');

    /* draw calculator */
    var amt = amountMg(root);
    var dOk = ok && isFinite(amt);
    var vol = dOk ? amt / conc : NaN;                  /* mL */
    var units = dOk ? vol * 100 : NaN;
    set('vol', dOk ? fmt(vol, 3) + ' mL' : '--');
    set('units', dOk ? fmt(units, 1) + ' units' : '--');
    var scale = q(root, '[data-pp-calc-scale]');
    var range = q(root, '[data-pp-calc-range]');
    if (scale) {
      var pct = dOk ? Math.max(0, Math.min(100, units)) : 0;
      scale.style.setProperty('--fill', pct + '%');
      if (range && !opts.fromRange) range.value = String(Math.round(pct * 2) / 2);
      if (range) {
        range.setAttribute('aria-valuetext', dOk ? fmt(units, 1) + ' units, ' + fmt(vol, 3) + ' mL' : 'no value');
      }
    }
    var over = q(root, '[data-pp-calc-over]');
    if (over) over.hidden = !(dOk && units > 100 + 1e-9);

    /* U-100 reference table */
    var body = q(root, '[data-pp-calc-rows]');
    if (body) {
      var step = num(body.getAttribute('data-step')) || 10;
      var html = '';
      for (var u = step; u <= 100 + 1e-9; u += step) {
        var v = u / 100;
        html += '<tr><td>' + fmtLoose(u, 1) + ' units</td><td>' + fmt(v, 2) + ' mL</td><td>' +
                (ok ? fmtMcg(v * conc * 1000) : '--') + '</td></tr>';
      }
      body.innerHTML = html;
    }
    markPills(root);
  }

  /* product select: autofill vial content and reference weight */
  function applyProduct(root) {
    var sel = q(root, '[data-pp-calc-product]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var note = q(root, '[data-pp-calc-mwnote]');
    if (!opt || !opt.value) {                          /* "other compound": leave the fields alone */
      if (note) note.hidden = true;
      compute(root);
      return;
    }
    var mg = parseMass(opt.getAttribute('data-mg'));
    var mw = num(opt.getAttribute('data-mw'));
    var mgIn = q(root, '[data-pp-calc-mg]');
    var mwIn = q(root, '[data-pp-calc-mw]');
    if (mgIn && isFinite(mg) && mg > 0) mgIn.value = fmtLoose(mg, 3).replace(/,/g, '');
    if (mwIn) mwIn.value = isFinite(mw) && mw > 0 ? String(mw) : '';
    if (note) note.hidden = isFinite(mw) && mw > 0;
    compute(root);
  }

  /* slider drag: reverse the draw calculation into the amount field */
  function fromRange(root, range) {
    var mg = num(q(root, '[data-pp-calc-mg]').value);
    var ml = num(q(root, '[data-pp-calc-ml]').value);
    if (!(mg > 0 && ml > 0)) return;
    var conc = mg / ml;
    var units = num(range.value);
    var amtMg = units / 100 * conc;
    var input = q(root, '[data-pp-calc-amount]');
    if (!input) return;
    input.value = unitOf(root) === 'mg' ? fmtLoose(amtMg, 3).replace(/,/g, '')
                                        : fmtLoose(amtMg * 1000, 1).replace(/,/g, '');
    compute(root, { fromRange: true });
  }

  function setUnit(root, unit) {
    var cur = unitOf(root);
    if (cur === unit) return;
    var input = q(root, '[data-pp-calc-amount]');
    var a = num(input.value);
    qa(root, '[data-pp-calc-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-pp-calc-unit') === unit ? 'true' : 'false');
    });
    if (isFinite(a)) {                                  /* keep the physical amount, change the label */
      input.value = unit === 'mg' ? fmtLoose(a / 1000, 4).replace(/,/g, '')
                                  : fmtLoose(a * 1000, 1).replace(/,/g, '');
    }
    compute(root);
  }

  function copyTable(root, btn) {
    var conc = q(root, '[data-pp-calc-out="mgml"]');
    var lines = [(btn.getAttribute('data-title') || 'U-100 syringe mark reference') +
                 (conc ? ' at ' + conc.textContent + ' mg/mL' : '')];
    qa(root, '[data-pp-calc-rows] tr').forEach(function (tr) {
      lines.push(qa(tr, 'td').map(function (td) { return td.textContent; }).join('\t'));
    });
    var text = lines.join('\n');
    var done = function () {
      var lab = q(btn, '[data-pp-calc-copylabel]');
      var live = q(root, '[data-pp-calc-live]');
      var was = btn.getAttribute('data-label') || '';
      var msg = btn.getAttribute('data-copied') || 'Copied';
      if (lab) lab.textContent = msg;
      if (live) live.textContent = msg;
      btn.setAttribute('data-done', '1');
      setTimeout(function () {
        if (lab) lab.textContent = was;
        btn.removeAttribute('data-done');
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text); done(); });
    } else {
      legacyCopy(text); done();
    }
  }
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.top = '-1000px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing to do */ }
    document.body.removeChild(ta);
  }

  /* ---- delegated events ------------------------------------------ */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest(SEL);
    if (!root) return;
    if (t.hasAttribute('data-pp-calc-range')) { fromRange(root, t); return; }
    compute(root);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest(SEL);
    if (!root) return;
    if (t.hasAttribute('data-pp-calc-product')) applyProduct(root);
  });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-pp-calc-pill],[data-pp-calc-unit],[data-pp-calc-stepper],[data-pp-calc-copy]') : null;
    if (!t) return;
    var root = t.closest(SEL);
    if (!root) return;
    e.preventDefault();
    if (t.hasAttribute('data-pp-calc-pill')) {
      var ml = q(root, '[data-pp-calc-ml]');
      ml.value = t.getAttribute('data-pp-calc-pill');
      compute(root);
    } else if (t.hasAttribute('data-pp-calc-unit')) {
      setUnit(root, t.getAttribute('data-pp-calc-unit'));
    } else if (t.hasAttribute('data-pp-calc-stepper')) {
      var mw = q(root, '[data-pp-calc-mw]');
      var cur = num(mw.value);
      if (!isFinite(cur)) cur = 0;
      var next = cur + (t.getAttribute('data-pp-calc-stepper') === 'up' ? 1 : -1);
      if (next < 0) next = 0;
      mw.value = String(Math.round(next * 100) / 100);
      compute(root);
    } else if (t.hasAttribute('data-pp-calc-copy')) {
      copyTable(root, t);
    }
  });

  /* Enter in a field should never submit anything on this page. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.closest && t.closest(SEL) && t.tagName === 'INPUT') e.preventDefault();
  });

  /* ---- init / re-hydrate ------------------------------------------ */
  function initRoot(root) {
    if (root.getAttribute('data-pp-calc-ready') === '1') { compute(root); return; }
    root.setAttribute('data-pp-calc-ready', '1');
    applyProduct(root);                                 /* also computes */
  }
  function initIn(scope) {
    if (!scope || !scope.querySelectorAll) return;
    qa(scope, SEL).forEach(initRoot);
    if (scope.matches && scope.matches(SEL)) initRoot(scope);
  }
  function initAll() { initIn(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
})();
